<template>
  <b-row
    class="d-flex flex-row align-items-start justify-content-start"
    no-gutters
  >
    <b-col class="d-flex flex-column align-items-start justify-content-start">
      <!-- Add a About form -->
      <h6
        class="text-left text-dark font-weight-semi-bold font-primary mb-3 mt-3"
      >
        About
      </h6>
      <form
        id="admin-registration-form"
        class="d-flex flex-column align-items-start justify-content-start w-100"
      >
        <b-row
          class="d-flex flex-row align-items-start justify-content-start w-100 py-2"
          no-gutters
        >
          <b-col cols="12">
            <!-- text editor -->
            <vue-editor
              class="editor mb-4"
              v-model="aboutText"
              :editor-toolbar="customToolbar"
            >
            </vue-editor>
          </b-col>
        </b-row>
        <!-- form action -->
        <b-row
          v-if="saveAboutError.status"
          class="d-flex flex-row align-items-center justify-content-center w-100"
          no-gutters
        >
          <!-- error message span class -->
          <b-col
            class="d-flex flex-column align-items-center justify-content-center px-0 py-2"
            cols="9"
          >
            <span class="text-danger text-center" style="font-size: 0.8rem">{{
              saveAboutError.message
            }}</span>
          </b-col>
        </b-row>
        <b-row
          class="d-flex flex-row align-items-center justify-content-center w-100"
          no-gutters
        >
          <b-col
            class="d-flex flex-column align-items-center justify-content-center px-0 py-2"
            cols="6"
          >
            <FormButton
              variant="primary"
              isBlock
              class="font-weight-normal text-white mt-4 border-dark"
              type="submit"
              @click.native="saveData"
              :isLoading="isAPILoading"
              :isDisabled="isAPILoading"
            >
              Save Changes
            </FormButton>
          </b-col>
        </b-row>
      </form>
    </b-col>
    <!-- overlay loader -->
    <b-overlay :show="initLoading" class="mx-n3" no-wrap></b-overlay>
  </b-row>
</template>

<script>
// components
import FormButton from "@/components/Form/FormButton";

// services
import { SaveAbout, GetAbout } from "@/services/content.service";

export default {
  name: "About",
  components: {
    FormButton,
  },
  created() {
    this.onInit();
  },
  data() {
    return {
      initLoading: false,
      isAPILoading: false,
      aboutText: null,
      aboutTextError: {
        status: null,
        message: null,
      },
      saveAboutError: {
        status: null,
        message: null,
      },

      customToolbar: [
        ["bold", "italic", "underline"],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "left" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link"],
      ],
    };
  },
  watch: {
    aboutText(val) {
      this.saveAboutError.status = false;
      this.errorFn(val);
    },
  },
  methods: {
    closeModal() {
      this.$emit("onClose");
    },
    async onInit() {
      try {
        this.initLoading = true;
        var { data } = await GetAbout();

        if (data.code == 200 && data.message == "success") {
          if (data.content) this.aboutText = data.content.about;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.initLoading = false;
      }
    },
    async saveData() {
      try {
        this.isAPILoading = true;
        var errors = this.errorFn();
        if (errors.length == 0) {
          let payload = {
            about: this.aboutText,
          };
          let { data } = await SaveAbout(payload);
          if (data && data.code == 200 && data.message == "success") {
            let payloadNotify = {
              isToast: true,
              title: "About Content",
              content: "About Content was saved successfully",
              variant: "success",
            };
            this.$store.dispatch("notification/setNotify", payloadNotify);
            this.$emit("reloadFn");
          } else if (data) {
            this.saveAboutError.status = true;
            this.saveAboutError.message = `An error occured when saving the About Content: ${data.details}`;
            this.handleErrorFn("About Content was not saved", [
              data.details,
              data.errorCode,
            ]);
          } else throw new Error("Error saving details");
        } else {
          this.handleErrorFn(
            "It seems like you have missed some important fields when saving the About Content",
            errors
          );
        }
      } catch (error) {
        this.saveAboutError.status = true;
        this.saveAboutError.message = `An error occured when saving the About Content: ${error.message}`;
        this.handleErrorFn("About Content was not saved", [error.message]);
      } finally {
        this.isAPILoading = false;
      }
    },
    handleErrorFn(content, list) {
      var payloadNotify = {
        isToast: true,
        title: "ERROR! About Content",
        content,
        list,
        variant: "danger",
      };
      this.$store.dispatch("notification/setNotify", payloadNotify);
    },
    errorFn(aboutText = this.aboutText) {
      var aboutTextError = this.validateAboutText(aboutText);
      if (aboutTextError.length > 0) {
        this.aboutTextError.status = false;
        this.aboutTextError.message = aboutTextError[0];
      } else this.aboutTextError.status = true;
      return [...aboutTextError];
    },
    validateAboutText(val) {
      var errorList = [];
      if (!val) errorList.push("Please fill in the About Content");
      return errorList;
    },
  },
};
</script>
<style scoped>
.editor {
  height: 750px;
  max-height: calc(100vh - 120px);
}
.editor >>> .ql-tooltip {
  z-index: 50;
}
</style>
